import {useGetPlan} from './swr';
import useParseURL from './useParseURL';

export const useGetPlanStartEndDate = () => {
  const {planId} = useParseURL();
  const {data: plan} = useGetPlan({resourceId: planId});

  if (!plan) {
    return {startDate: undefined, endDate: undefined};
  }

  const startDate = new Date(plan.startDate);
  const endDate = new Date(plan.endDate);

  return {startDate, endDate};
};
